/* Aubelys · sections aub-pyj-* : galerie, offres (coloris/taille par pyjama), ajout au panier (tiroir du thème), vidéo lue quand visible. */
(function () {
  'use strict';
  /* le fichier est inclus par plusieurs sections : une seule exécution, sinon chaque clic partirait plusieurs fois */
  if (window.aubPyjInit) return;
  window.aubPyjInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  /* galerie : miniatures + flèches */
  $$('[data-aubp-gal]').forEach(function (g) {
    var tr = $('.aubp-gal__track', g), th = $$('.aubp-thumbs__list button', g);
    if (!tr) return;
    var idx = function () { return Math.round(tr.scrollLeft / tr.clientWidth); };
    var go = function (i) { i = Math.max(0, Math.min(th.length - 1, i)); tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); };
    th.forEach(function (b, i) { b.onclick = function () { go(i); }; });
    $$('.aubp-arrow', g).forEach(function (b) { b.onclick = function () { go(idx() + (+b.getAttribute('data-dir'))); }; });
    tr.addEventListener('scroll', function () { var k = idx(); th.forEach(function (b, i) { b.setAttribute('aria-current', String(i === k)); }); }, { passive: true });
  });

  /* offres : une offre ouverte à la fois ; le bouton ajoute un pyjama par ligne (coloris + taille choisis) */
  $$('[data-aubp-buy]').forEach(function (col) {
    var variants = [];
    try { variants = JSON.parse($('[data-aubp-variants]', col).textContent) || []; } catch (e) {}
    var offers = $$('.aubp-offer', col), btn = $('[data-aubp-atc]', col), msg = $('[data-aubp-msg]', col), cartEl = $('cart-drawer');
    var sync = function () { offers.forEach(function (o) { o.classList.toggle('is-on', $('input', o).checked); }); };
    offers.forEach(function (o) { $('input', o).addEventListener('change', sync); });
    sync();
    var findVariant = function (vals) {
      return variants.filter(function (v) { return v.options.every(function (x, i) { return x === vals[i]; }); })[0];
    };
    if (!btn) return;
    /* rebond : 1 s d'animation, relancée toutes les 6 s */
    var bounce = function () { btn.classList.remove('is-bounce'); void btn.offsetWidth; btn.classList.add('is-bounce'); };
    bounce(); setInterval(bounce, 6000);
    btn.addEventListener('click', function () {
      var on = offers.filter(function (o) { return o.classList.contains('is-on'); })[0];
      if (!on) return;
      var counts = {}, order = [], missing = false;
      $$('[data-aubp-row]', on).forEach(function (row) {
        var vals = $$('select', row).map(function (s) { return s.value; });
        var v = findVariant(vals);
        if (!v || !v.available) { missing = true; return; }
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id]++;
      });
      if (missing) { if (msg) msg.textContent = 'Ce coloris n’est plus disponible dans cette taille.'; return; }
      var body = { items: order.map(function (id) { return { id: id, quantity: counts[id] }; }) };
      if (cartEl) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (o) {
          btn.disabled = false;
          if (!o.ok) { if (msg) msg.textContent = o.j.description || 'Impossible d’ajouter le pyjama au panier.'; return; }
          if (msg) msg.textContent = '';
          if (cartEl && typeof cartEl.renderContents === 'function') { cartEl.renderContents(o.j); cartEl.classList.remove('is-empty'); var inn = cartEl.querySelector('.drawer__inner'); if (inn) inn.classList.remove('is-empty'); if (typeof cartEl.open === 'function' && !cartEl.classList.contains('active')) cartEl.open(); }
          else window.location = root + 'cart';
        })
        .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Une erreur est survenue, réessayez.'; });
    });
  });

  /* avis : « voir plus » affiche la page suivante */
  $$('[data-aubp-reviews]').forEach(function (rv) {
    var per = +rv.getAttribute('data-per') || 20, more = $('[data-aubp-more]', rv), grid = $('.aubp-rv__grid', rv);
    var items = $$('.aubp-rv__item', rv), ncols = 0;
    /* répartition alternée gauche / droite, comme le widget de la source (2 colonnes mobile, 4 ordinateur) */
    var layout = function () {
      var n = window.innerWidth >= 990 ? 4 : 2;
      if (n === ncols && !layout.force) return;
      ncols = n; layout.force = false;
      var cols = [];
      grid.innerHTML = '';
      for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'aubp-rv__col'; grid.appendChild(c); cols.push(c); }
      items.forEach(function (it, i) { cols[i % n].appendChild(it); });
      grid.classList.add('is-js');
    };
    layout();
    window.addEventListener('resize', layout, { passive: true });
    if (!more) return;
    more.addEventListener('click', function () {
      var hid = items.filter(function (x) { return x.hidden; });
      hid.slice(0, per).forEach(function (x) { x.hidden = false; });
      if (hid.length <= per) more.parentNode.hidden = true;
    });
  });

  /* vidéo de démonstration : chargée et lue seulement quand elle est à l'écran, muette, en boucle (comme la source) */
  var vids = $$('video[data-aubp-autoplay]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.hasAttribute('data-src')) { v.src = v.getAttribute('data-src'); v.removeAttribute('data-src'); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '100px' });
    vids.forEach(function (v) { io.observe(v); });
  }
  /* témoignage : glisse vers le haut en apparaissant à l'écran (animate--slide-in de la source) ; sans JS, il reste simplement affiché */
  var sl = $$('.aubp-slide');
  if (sl.length && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); e.target.classList.remove('is-off'); so.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    sl.forEach(function (x) { if (x.getBoundingClientRect().top > window.innerHeight) { x.classList.add('is-off'); so.observe(x); } });
  }
})();
/* barre fixe d'achat : visible une fois les offres et le bouton principal dépassés (sortis par le haut) ; son bouton fait défiler jusqu'aux offres */
(function () {
  var bar = document.querySelector('[data-aubp-sticky]'), offers = document.querySelector('.aubp-offers'), atc = document.querySelector('[data-aubp-atc]');
  if (!bar || !offers || !('IntersectionObserver' in window)) return;
  var btn = bar.querySelector('[data-aubp-sticky-btn]'), seen = new Map();
  btn.addEventListener('click', function () {
    offers.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    var r = offers.querySelector('input:checked') || offers.querySelector('input'); if (r) r.focus({ preventScroll: true });
  });
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
    var show = !Array.from(seen.values()).some(Boolean) && offers.getBoundingClientRect().bottom < 0; /* seulement une fois les offres dépassées vers le bas */
    bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', String(!show)); btn.tabIndex = show ? 0 : -1;
  });
  io.observe(offers); if (atc) io.observe(atc);
})();
/* pop-up guide des tailles : lien des offres, croix, clic à l'extérieur, Échap (natif) */
(function () {
  var dlg = document.querySelector('[data-aubp-size-dlg]'); if (!dlg || !dlg.showModal) return;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-aubp-size-open]')) { e.preventDefault(); dlg.showModal(); }
    else if (e.target.closest('[data-aubp-size-close]') || e.target === dlg) dlg.close();
  });
})();
/* liste des coloris du bundle avec pastilles : bouton + liste, la vraie liste (select) reste derrière pour le panier */
(function () {
  function close(w, focusBtn) {
    var l = w.querySelector('.aubp-sel__list'), b = w.querySelector('.aubp-sel__btn');
    l.hidden = true; b.setAttribute('aria-expanded', 'false'); if (focusBtn) b.focus();
  }
  function closeAll(except) { document.querySelectorAll('[data-aubp-csel]').forEach(function (w) { if (w !== except) close(w); }); }
  function sync(w) {
    var s = w.querySelector('select'), o = s.options[s.selectedIndex];
    w.querySelector('[data-aubp-dot]').style.background = (o && o.getAttribute('data-hex')) || 'transparent';
    w.querySelector('[data-aubp-cur]').textContent = o ? o.text : '';
    w.querySelectorAll('[role=option]').forEach(function (li) { li.setAttribute('aria-selected', li.getAttribute('data-v') === s.value ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.aubp-sel__btn'), li = e.target.closest('.aubp-sel__list [role=option]');
    if (btn) {
      var w = btn.closest('[data-aubp-csel]'), l = w.querySelector('.aubp-sel__list'), open = l.hidden;
      closeAll(w); l.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var cur = l.querySelector('[aria-selected=true]') || l.querySelector('[role=option]'); cur && cur.focus(); }
      return;
    }
    if (li) {
      var w2 = li.closest('[data-aubp-csel]'), s = w2.querySelector('select');
      s.value = li.getAttribute('data-v'); s.dispatchEvent(new Event('change', { bubbles: true })); close(w2, true);
      return;
    }
    closeAll();
  });
  document.addEventListener('keydown', function (e) {
    var li = e.target.closest && e.target.closest('.aubp-sel__list [role=option]');
    if (!li) return;
    var w = li.closest('[data-aubp-csel]');
    if (e.key === 'Escape') { e.preventDefault(); close(w, true); }
    else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); var n = e.key === 'ArrowDown' ? li.nextElementSibling : li.previousElementSibling; n && n.focus(); }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.click(); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-aubp-color]')) sync(e.target.closest('[data-aubp-csel]'));
  });
})();
